import React from 'react';
import { FormControl, MenuItem, Select, styled } from '@mui/material';
import RestUtilities from '../../services/RestUtilities';
import { useGetLiveArtists } from '../../hooks/useGetLiveArtists';
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from 'recoil';
import {
  artistState,
  audioState,
  galleryState,
  liveArtistsState,
  loadingState,
  songlistState,
  uploadsState,
  videosState,
  youTubeVideosState,
} from '../../state/RecoilState';

const ArtistSelector = () => {
  const [artist, setArtist] = useRecoilState(artistState);
  const liveArtists = useRecoilValue(liveArtistsState);
  const resetGallery = useResetRecoilState(galleryState);
  const resetVideos = useResetRecoilState(videosState);
  const resetSonglist = useResetRecoilState(songlistState);
  const resetAudio = useResetRecoilState(audioState);
  const resetUploads = useResetRecoilState(uploadsState);
  const resetYouTubeVideos = useResetRecoilState(youTubeVideosState);
  const setLoading = useSetRecoilState(loadingState);

  useGetLiveArtists();

  const onArtistSelect = async (e: any) => {
    setLoading(true);
    const url = `api/artist/Get/${e.target.value}`;
    const response = await RestUtilities.get(url);
    if (response.ok) {
      setArtist(response.content);
      resetGallery();
      resetVideos();
      resetSonglist();
      resetAudio();
      resetUploads();
      resetYouTubeVideos();
    }
    setLoading(false);
  };

  const CustomSelect = styled(Select)(() => ({
    borderWidth: 1,
    height: 30,
    width: 180,
    '&.MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'white',
      },
      '&:hover fieldset': {
        borderColor: '#DDD',
      },
      '&.Mui-focused fieldset': {
        borderColor: 'white',
      },
      svg: {
        color: 'white',
      },
    },
  }));

  return (
    <FormControl>
      <CustomSelect
        labelId='artist-select-label'
        id='demo-simple-select'
        onChange={onArtistSelect}
        defaultValue={artist ? artist.slug : 'Select'}
        sx={{ color: 'white' }}
      >
        {liveArtists?.map((a: any) => {
          return (
            <MenuItem key={a.artistId} value={a.slug} sx={{ color: 'black' }}>
              {a.artistName}
            </MenuItem>
          );
        })}
      </CustomSelect>
    </FormControl>
  );
};

export default ArtistSelector;
